let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("cG8r2")).then(() => parcelRequire('5NaVN'));